/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Doc_Claim_TitleInputs */

const en_faq_doc_claim_title = /** @type {(inputs: Faq_Doc_Claim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting a Claim Guide`)
};

const fr_faq_doc_claim_title = /** @type {(inputs: Faq_Doc_Claim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de soumission de réclamation`)
};

/**
* | output |
* | --- |
* | "Submitting a Claim Guide" |
*
* @param {Faq_Doc_Claim_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_doc_claim_title = /** @type {((inputs?: Faq_Doc_Claim_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Doc_Claim_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_doc_claim_title(inputs)
	return fr_faq_doc_claim_title(inputs)
});